/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendIndustryDto } from '../../models/backend-industry-dto';

export interface ProjectsIndustriesList$Params {
  locale?: string;
  name?: string;

  /**
   * A search term.
   */
  search?: string;
}

export function projectsIndustriesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsIndustriesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendIndustryDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsIndustriesList.PATH, 'get');
  if (params) {
    rb.query('locale', params.locale, {});
    rb.query('name', params.name, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendIndustryDto>>;
    }),
  );
}

projectsIndustriesList.PATH = '/api/projects/industries/';
